export default __webpack_public_path__ + "static/media/arroz.4ac72088.png";